import React from 'react';

const VARIANTS = {
  // Shipment statuses
  preparing:    { bg: 'bg-slate-100',    text: 'text-slate-700',   ring: 'ring-slate-200',   dot: 'bg-slate-400'   },
  transit:      { bg: 'bg-sky-50',       text: 'text-sky-800',     ring: 'ring-sky-200',     dot: 'bg-teal-600'    },
  delivered:    { bg: 'bg-emerald-50',   text: 'text-emerald-800', ring: 'ring-emerald-200', dot: 'bg-emerald-600' },
  incident:     { bg: 'bg-rose-50',      text: 'text-rose-800',    ring: 'ring-rose-200',    dot: 'bg-rose-600'    },
  // Invoice statuses
  pending:      { bg: 'bg-amber-50',     text: 'text-amber-800',   ring: 'ring-amber-200',   dot: 'bg-amber-500'   },
  paid:         { bg: 'bg-emerald-50',   text: 'text-emerald-800', ring: 'ring-emerald-200', dot: 'bg-emerald-600' },
  overdue30:    { bg: 'bg-orange-50',    text: 'text-orange-800',  ring: 'ring-orange-200',  dot: 'bg-orange-500'  },
  overdue60:    { bg: 'bg-rose-50',      text: 'text-rose-800',    ring: 'ring-rose-200',    dot: 'bg-rose-600'    },
  disputed:     { bg: 'bg-violet-50',    text: 'text-violet-800',  ring: 'ring-violet-200',  dot: 'bg-violet-600'  },
  // Claim statuses
  investigation:{ bg: 'bg-amber-50',     text: 'text-amber-800',   ring: 'ring-amber-200',   dot: 'bg-amber-500'   },
  expertise:    { bg: 'bg-orange-50',    text: 'text-orange-800',  ring: 'ring-orange-200',  dot: 'bg-orange-500'  },
  indemnified:  { bg: 'bg-emerald-50',   text: 'text-emerald-800', ring: 'ring-emerald-200', dot: 'bg-emerald-600' },
  rejected:     { bg: 'bg-slate-100',    text: 'text-slate-700',   ring: 'ring-slate-200',   dot: 'bg-slate-500'   },
  ongoing:      { bg: 'bg-sky-50',       text: 'text-sky-800',     ring: 'ring-sky-200',     dot: 'bg-teal-600'    },
  resolved:     { bg: 'bg-emerald-50',   text: 'text-emerald-800', ring: 'ring-emerald-200', dot: 'bg-emerald-600' },
  // Customs admission statuses
  open:         { bg: 'bg-slate-100',    text: 'text-slate-700',   ring: 'ring-slate-200',   dot: 'bg-slate-400'   },
  attention:    { bg: 'bg-amber-50',     text: 'text-amber-800',   ring: 'ring-amber-200',   dot: 'bg-amber-500'   },
  urgent:       { bg: 'bg-orange-50',    text: 'text-orange-800',  ring: 'ring-orange-200',  dot: 'bg-orange-500'  },
  overdue:      { bg: 'bg-rose-50',      text: 'text-rose-800',    ring: 'ring-rose-200',    dot: 'bg-rose-600'    },
  cleared:      { bg: 'bg-emerald-50',   text: 'text-emerald-800', ring: 'ring-emerald-200', dot: 'bg-emerald-600' },
  // Generic
  info:         { bg: 'bg-sky-50',       text: 'text-sky-800',     ring: 'ring-sky-200',     dot: 'bg-sky-600'     },
  warning:      { bg: 'bg-amber-50',     text: 'text-amber-800',   ring: 'ring-amber-200',   dot: 'bg-amber-500'   },
  danger:       { bg: 'bg-rose-50',      text: 'text-rose-800',    ring: 'ring-rose-200',    dot: 'bg-rose-600'    },
  success:      { bg: 'bg-emerald-50',   text: 'text-emerald-800', ring: 'ring-emerald-200', dot: 'bg-emerald-600' },
};

const TIER_VARIANTS = {
  bronze:   'bg-slate-100 text-slate-600',
  silver:   'bg-slate-200 text-slate-700',
  gold:     'bg-amber-100 text-amber-800',
  platinum: 'bg-sky-100 text-sky-800',
};

export function Badge({ variant = 'info', children, className = '' }) {
  const v = VARIANTS[variant] || VARIANTS.info;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold ring-1 ${v.bg} ${v.text} ${v.ring} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${v.dot}`} />
      {children}
    </span>
  );
}

export function TierBadge({ tier = 'bronze', children }) {
  const cls = TIER_VARIANTS[tier] || TIER_VARIANTS.bronze;
  return (
    <span className={`text-[10.5px] font-semibold px-2 py-0.5 rounded ${cls}`}>
      {children}
    </span>
  );
}

export function CountBadge({ count, variant = 'accent' }) {
  const cls =
    variant === 'danger'
      ? 'bg-rose-600 text-white'
      : 'bg-accent text-white';
  return (
    <span className={`text-[10.5px] font-bold px-1.5 py-0.5 rounded-full ${cls}`}>
      {count}
    </span>
  );
}

export default Badge;
